"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Grid = exports.FilterType = void 0;
var React = require("react");
var semantic_ui_react_1 = require("semantic-ui-react");
var __1 = require("../..");
var styled_1 = require("../../styled");
var index_1 = require("../../theme/index");
var titleCase_1 = require("../../utils/titleCase");
var Badge_1 = require("../Badge");
var Button_1 = require("../Button");
var DatetimePicker_1 = require("../DatetimePicker");
var Dropdown_1 = require("../Dropdown");
var EmptyState_1 = require("../EmptyState");
var Loader_1 = require("../Loader");
var TextField_1 = require("../TextField");
var runOptionsBuilders_1 = require("./runOptionsBuilders");
var FilterType;
(function (FilterType) {
    FilterType[FilterType["TextMatch"] = 0] = "TextMatch";
    FilterType[FilterType["ListSelection"] = 1] = "ListSelection";
    FilterType[FilterType["DatePicker"] = 2] = "DatePicker";
    FilterType[FilterType["Number"] = 3] = "Number";
    FilterType[FilterType["DateTimePicker"] = 4] = "DateTimePicker";
})(FilterType = exports.FilterType || (exports.FilterType = {}));
var Grid = /** @class */ (function (_super) {
    __extends(Grid, _super);
    function Grid(props) {
        var _this = _super.call(this, props) || this;
        _this.toggleFiltering = function (e) {
            e.preventDefault();
            _this.setState({
                filtering: !_this.state.filtering,
            }, _this.clearTargetFilter);
        };
        _this.filterSelected = function (_e, _a) {
            var value = _a.value;
            var filter = (_this.props.filters || []).filter(function (f) { return f.value === value; });
            if (filter) {
                _this.setState({ targetFilter: filter[0] });
            }
        };
        _this.clearTargetFilter = function () {
            _this.setState({
                endDate: null,
                startDate: null,
                targetFilter: undefined,
                targetFilterValue: undefined,
                targetFilterValue2: undefined,
                targetOperatorValue: undefined,
            });
        };
        _this.cancelFilterAdding = function () {
            _this.clearTargetFilter();
        };
        _this.addFilter = function () {
            var onFilterApplied = _this.props.onFilterApplied;
            var _a = _this.state, targetFilter = _a.targetFilter, targetFilterValue = _a.targetFilterValue, targetFilterValue2 = _a.targetFilterValue2, targetOperatorValue = _a.targetOperatorValue;
            if (typeof onFilterApplied === 'function' &&
                typeof targetFilter !== 'undefined' &&
                typeof targetFilterValue !== 'undefined') {
                onFilterApplied(targetFilter, targetFilterValue, targetOperatorValue, targetFilterValue2);
            }
            _this.clearTargetFilter();
        };
        _this.onTextFilterValueChanged = function (e) {
            _this.setState({
                targetFilterValue: e.target.value,
            });
        };
        _this.onTextFilterValue2Changed = function (e) {
            _this.setState({
                targetFilterValue2: e.target.value,
            });
        };
        _this.onDropdownFilterValueChanged = function (_e, option) {
            _this.setState({
                targetFilterValue: option.value,
            });
        };
        _this.onDropdownOperatorValueChanged = function (_e, option) {
            var isSpecialOperator = !!(option.value === 'today' ||
                option.value === 'yesterday' ||
                option.value === 'lastWeek' ||
                option.value === 'lastMonth');
            _this.setState({
                targetFilterValue: isSpecialOperator
                    ? option.value
                    : _this.state.targetFilterValue,
                targetOperatorValue: option.value,
            });
        };
        _this.onStartDateChanged = function (date) {
            _this.setState({
                startDate: date,
                targetFilterValue: date,
            });
        };
        _this.onEndDateChanged = function (date) {
            var _a;
            var value = ((_a = _this.state.targetFilter) === null || _a === void 0 ? void 0 : _a.type) === FilterType.DatePicker
                ? date.endOf('day') : date;
            _this.setState({
                endDate: value,
                targetFilterValue2: value,
            });
        };
        _this.onDateFilterValueChanged = function (date) {
            var value = date;
            switch (_this.state.targetOperatorValue) {
                case 'greaterThan':
                    value = value.endOf('day');
                    break;
                case 'greaterThanOrEqualTo':
                    value = value.startOf('day');
                    break;
                case 'lessThan':
                    value = value.startOf('day');
                    break;
                case 'lessThanOrEqualTo':
                    value = value.endOf('day');
                    break;
                default:
                    break;
            }
            _this.setState({
                startDate: value,
                targetFilterValue: value,
            });
        };
        _this.getTextFilterDisplayOperator = function (filter) {
            return filter.operator === 'like' ? 'contains' : '=';
        };
        _this.isRowChecked = function (data) {
            var _a = _this.props, _b = _a.selectedItems, selectedItems = _b === void 0 ? [] : _b, _c = _a.selectionKey, selectionKey = _c === void 0 ? '' : _c;
            var selectedIndex = selectedItems.findIndex(function (item) { return item[selectionKey] === data[selectionKey]; });
            return selectedIndex >= 0;
        };
        _this.isSelectableColumnChecked = function () {
            var _a = _this.props.data, data = _a === void 0 ? [] : _a;
            // tslint:disable-next-line:prefer-for-of
            for (var i = 0; i < data.length; ++i) {
                var isRowChecked = _this.isRowChecked(data[i]);
                if (!isRowChecked) {
                    return false;
                }
            }
            return true;
        };
        _this.renderSearch = function () {
            var _a = _this.props, _b = _a.additionalMenuItems, additionalMenuItems = _b === void 0 ? null : _b, _c = _a.displaySearch, displaySearch = _c === void 0 ? true : _c, filters = _a.filters, onSearchChanged = _a.onSearchChanged, onTopRightFilterChanged = _a.onTopRightFilterChanged, _d = _a.searchBarStyle, searchBarStyle = _d === void 0 ? {} : _d, searchPlaceholder = _a.searchPlaceholder, searchRowElement = _a.searchRowElement, _f = _a.searchValue, searchValue = _f === void 0 ? '' : _f, topRightFilter = _a.topRightFilter;
            return (React.createElement("div", { style: flexSpaceBetween },
                React.createElement(semantic_ui_react_1.Form, null, displaySearch ? (React.createElement("div", { style: {
                        display: 'flex',
                        alignItems: 'center',
                    } },
                    React.createElement(TextField_1.TextField, { icon: "search", onChange: onSearchChanged, placeholder: searchPlaceholder || 'Search...', style: __assign({ width: '27.333rem', height: '3rem' }, searchBarStyle), value: searchValue }),
                    filters && filters.length > 0 && (React.createElement(FilterDataLink, { href: "#", onClick: _this.toggleFiltering }, "Filter Data")))) : ('')),
                searchRowElement,
                React.createElement("div", { style: { display: 'flex', alignItems: 'center' } },
                    additionalMenuItems,
                    topRightFilter && (React.createElement(React.Fragment, null,
                        React.createElement("span", { style: topRightFilterLabel }, topRightFilter.label),
                        React.createElement(Dropdown_1.Dropdown, { inline: true, onChange: function (_e, data) {
                                return onTopRightFilterChanged &&
                                    onTopRightFilterChanged(topRightFilter.key, data.value);
                            }, options: topRightFilter.options, simple: true, size: "small", value: topRightFilter.value !== undefined
                                ? topRightFilter.value
                                : undefined }))))));
        };
        _this.renderFilterSelection = function () {
            var _a = _this.state, targetFilter = _a.targetFilter, targetFilterValue = _a.targetFilterValue, targetFilterValue2 = _a.targetFilterValue2, targetOperatorValue = _a.targetOperatorValue;
            var _b = _this.props, _c = _b.breakFiltersVertically, breakFiltersVertically = _c === void 0 ? false : _c, data = _b.data, filters = _b.filters, sortMainFilterOptions = _b.sortMainFilterOptions;
            if (filters && filters.length > 0) {
                runOptionsBuilders_1.runOptionsBuilders(filters, data, {
                    rekey: true,
                    shouldUniqifyOptions: true,
                });
            }
            return (React.createElement("div", { style: filterSectionWrapper },
                React.createElement("div", { style: __assign(__assign({}, flexSpaceBetween), { alignItems: 'center' }) },
                    React.createElement("h6", { style: { margin: "0" } }, "Filter Data"),
                    React.createElement("img", { onClick: _this.toggleFiltering, src: require('../../../assets/close.svg'), style: { cursor: 'pointer' } })),
                filters && filters.length > 0 ? (React.createElement(FilterFieldContainer, { alignItemsVertically: breakFiltersVertically },
                    React.createElement(Dropdown_1.Dropdown, { onChange: _this.filterSelected, options: filters
                            ? filters.map(function (f) { return ({
                                key: f.key,
                                text: f.customFieldDefinition ? (React.createElement("i", null, f.label)) : (f.label),
                                value: f.value,
                            }); })
                            : [], placeholder: "Select an attribute...", sortOptions: sortMainFilterOptions, value: (targetFilter === null || targetFilter === void 0 ? void 0 : targetFilter.value) || null }),
                    breakFiltersVertically && React.createElement("div", null),
                    targetFilter && (React.createElement(React.Fragment, null,
                        _this.renderOperatorDropdown(),
                        _this.renderTargetFilterFactory(),
                        React.createElement("div", { style: breakFiltersVertically
                                ? { marginTop: '3px' }
                                : { marginLeft: '0.66rem' } },
                            React.createElement(Button_1.Button, { disabled: targetFilterValue === undefined ||
                                    (targetOperatorValue === 'between' &&
                                        targetFilterValue2 === undefined), onClick: _this.addFilter, size: "small", variant: "primary" }, "Add Filter")))))) : (React.createElement("span", null, "No remaining filters"))));
        };
        _this.renderSelectedFilters = function () {
            var _a = _this.props, onFilterRemoveClicked = _a.onFilterRemoveClicked, selectedFilters = _a.selectedFilters;
            return (React.createElement(SelectedFiltersWrapper, null, selectedFilters &&
                selectedFilters.length > 0 &&
                selectedFilters.map(function (f) { return (React.createElement(Badge_1.default, { key: f.key, onClick: function () {
                        // tslint:disable-next-line:no-unused-expression
                        typeof onFilterRemoveClicked === 'function' &&
                            onFilterRemoveClicked(f);
                        if (selectedFilters.length <= 1) {
                            _this.clearTargetFilter();
                        }
                    }, style: { marginRight: '0.33rem', cursor: 'pointer' }, textWeight: "light" },
                    f.type === FilterType.TextMatch && (React.createElement(FilterSelectionSpan, null,
                        f.label,
                        " ",
                        _this.getTextFilterDisplayOperator(f),
                        " \"",
                        (f.getValueLabel && f.getValueLabel(f)) ||
                            f.value.toString(),
                        "\"",
                        React.createElement("img", { src: require('../../../assets/remove.svg') }))),
                    f.type === FilterType.ListSelection && (React.createElement(FilterSelectionSpan, null,
                        f.label,
                        " = \"",
                        (f.getValueLabel && f.getValueLabel(f)) ||
                            f.value.toString(),
                        "\"",
                        React.createElement("img", { src: require('../../../assets/remove.svg') }))),
                    (f.type === FilterType.DatePicker ||
                        f.type === FilterType.DateTimePicker ||
                        f.type === FilterType.Number) && (React.createElement(FilterSelectionSpan, null,
                        f.label,
                        (f.getValueLabel && f.getValueLabel(f)) ||
                            f.value.toString(),
                        React.createElement("img", { src: require('../../../assets/remove.svg') }))))); })));
        };
        _this.renderTableHeader = function (whichHeader) {
            var func = _this.props["renderTable" + whichHeader + "Header"];
            if (typeof func !== 'function') {
                return null;
            }
            return func(_this.props, _this.state);
        };
        _this.renderColumnHeader = function (column, index) {
            var _a = _this.props, onColumnClicked = _a.onColumnClicked, onToggleSelectionColumn = _a.onToggleSelectionColumn, _b = _a.selectable, selectable = _b === void 0 ? false : _b, _c = _a.sorted, sorted = _c === void 0 ? {} : _c;
            var _d = column.style, style = _d === void 0 ? {} : _d;
            var isSorted = !!sorted[column.key];
            var direction = sorted[column.key];
            var icon = React.createElement(React.Fragment, null);
            if (isSorted) {
                icon =
                    direction === 'DESC' ? (React.createElement(semantic_ui_react_1.Icon, { name: "caret down" })) : (React.createElement(semantic_ui_react_1.Icon, { name: "caret up" }));
            }
            else if (column.sortable) {
                icon = React.createElement(semantic_ui_react_1.Icon, { name: "sort" });
            }
            return (React.createElement(semantic_ui_react_1.Table.HeaderCell, { className: isSorted ? 'active' : '', key: "table-headercell-" + column.key + "-" + index, onClick: function () {
                    // tslint:disable-next-line:no-unused-expression
                    typeof onColumnClicked === 'function' && onColumnClicked(column);
                }, style: __assign({ cursor: column.sortable ? 'pointer' : 'auto', verticalAlign: 'top' }, style) }, selectable && index === 0 ? (React.createElement(semantic_ui_react_1.Checkbox, { checked: _this.isSelectableColumnChecked(), onChange: function (e, checkboxInfo) {
                    // tslint:disable-next-line:no-unused-expression
                    typeof onToggleSelectionColumn === 'function' &&
                        onToggleSelectionColumn(checkboxInfo, _this.props.data || []);
                } })) : (React.createElement("div", { className: "tableHeaderCell", style: {
                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between',
                } },
                React.createElement("div", { style: __assign({}, (!column.toolTip && {
                        paddingLeft: '0.25rem',
                        paddingRight: '0.25rem',
                    })) }, column.toolTip ? (React.createElement(semantic_ui_react_1.Popup, __assign({}, column.toolTip, { trigger: typeof column.name === 'string' ? (React.createElement("div", { style: column.toolTip.triggerStyle }, column.name)) : (column.name) }))) : (column.name)),
                React.createElement("div", null, icon)))));
        };
        _this.renderRowBody = function (data, index) {
            var _a = _this.props, onRowSelected = _a.onRowSelected, renderRow = _a.renderRow;
            var row = renderRow ? renderRow(data, index) : null;
            if (_this.props.selectable) {
                var newChildren = React.Children.toArray(row.props.children);
                newChildren.unshift(React.createElement(semantic_ui_react_1.Table.Cell, { key: "-.1" },
                    React.createElement(semantic_ui_react_1.Checkbox, { checked: _this.isRowChecked(data), onChange: function (e, checkboxInfo) {
                            // tslint:disable-next-line:no-unused-expression
                            typeof onRowSelected === 'function' &&
                                onRowSelected(checkboxInfo, data, index);
                        } })));
                row = React.cloneElement(row, { children: newChildren });
            }
            return row;
        };
        _this.renderTable = function () {
            var _a = _this.props, _b = _a.columns, columns = _b === void 0 ? [] : _b, _c = _a.data, data = _c === void 0 ? [] : _c, gridLoader = _a.gridLoader, isFetching = _a.isFetching, renderTable = _a.renderTable, _d = _a.selectable, selectable = _d === void 0 ? false : _d, unstackable = _a.unstackable;
            if (typeof renderTable === 'function') {
                return renderTable(data);
            }
            var modifiedColumns = columns.map(function (c) { return c; });
            if (selectable &&
                modifiedColumns[0] &&
                modifiedColumns[0].key !== 'Select') {
                modifiedColumns.unshift({
                    key: 'Select',
                    name: '',
                    sortable: false,
                });
            }
            return (React.createElement("div", null,
                React.createElement(semantic_ui_react_1.Table, { className: "datagrid", unstackable: unstackable },
                    React.createElement(semantic_ui_react_1.Table.Header, null,
                        React.createElement(semantic_ui_react_1.Table.Row, null,
                            React.createElement(semantic_ui_react_1.Table.Cell, { colSpan: modifiedColumns.length + 1 }, _this.renderTableHeader('Super'))),
                        React.createElement(semantic_ui_react_1.Table.Row, null, modifiedColumns.map(function (c, i) { return _this.renderColumnHeader(c, i); }))),
                    React.createElement(semantic_ui_react_1.Table.Header, null,
                        React.createElement(semantic_ui_react_1.Table.Row, null,
                            React.createElement(semantic_ui_react_1.Table.Cell, { className: "datagrid__subHeader", colSpan: modifiedColumns.length + 1, style: {
                                    paddingLeft: '0px',
                                    paddingRight: '0px',
                                } }, _this.renderTableHeader('Sub')))),
                    React.createElement(semantic_ui_react_1.Table.Body, null, (isFetching && gridLoader && _this.renderLoader(modifiedColumns)) ||
                        (data.length > 0 && data.map(_this.renderRowBody)))),
                !isFetching && _this.renderEmptyState()));
        };
        _this.getOperatorsByDataType = function (targetFilter) {
            if (targetFilter === undefined) {
                return [];
            }
            switch (targetFilter.type) {
                case FilterType.DatePicker:
                case FilterType.DateTimePicker:
                    return [
                        'between',
                        'today',
                        'yesterday',
                        'lastWeek',
                        'lastMonth',
                        'greaterThan',
                        'greaterThanOrEqualTo',
                        'lessThan',
                        'lessThanOrEqualTo',
                    ];
                case FilterType.Number:
                    return [
                        'between',
                        'greaterThan',
                        'greaterThanOrEqualTo',
                        'lessThan',
                        'lessThanOrEqualTo',
                    ];
                case FilterType.TextMatch:
                    return ['like', 'equals'];
                default:
                    return ['equals'];
            }
        };
        _this.renderOperatorDropdown = function () {
            var _a = _this.state, targetFilter = _a.targetFilter, targetOperatorValue = _a.targetOperatorValue;
            if (!targetFilter ||
                (targetFilter.options && targetFilter.options.length)) {
                return null;
            }
            var filterOperators = _this.getOperatorsByDataType(targetFilter);
            var operatorOptions = filterOperators.map(function (operator, index) { return ({
                key: operator + index,
                text: titleCase_1.titleCase(operator.replace(/([A-Z])/g, ' $1').trim()),
                value: operator,
            }); });
            return (React.createElement(Dropdown_1.Dropdown, { onChange: _this.onDropdownOperatorValueChanged, options: operatorOptions, placeholder: "Operator...", value: targetOperatorValue || undefined }));
        };
        _this.renderTargetFilterFactory = function () {
            var targetFilter = _this.state.targetFilter;
            var hideTimeInDateTimeFilter = _this.props.hideTimeInDateTimeFilter;
            if (targetFilter === undefined) {
                return null;
            }
            switch (targetFilter.type) {
                case FilterType.DatePicker:
                    return _this.renderDatePickerFilter();
                case FilterType.DateTimePicker:
                    return _this.renderDatePickerFilter(hideTimeInDateTimeFilter === undefined
                        ? true
                        : !hideTimeInDateTimeFilter);
                case FilterType.Number:
                    return _this.renderNumberFilter();
                case FilterType.TextMatch:
                    return _this.renderTextMatchFilter();
                default:
                    return _this.renderTargetFilterDefault();
            }
        };
        _this.renderTargetFilterDefault = function () {
            var _a = _this.state, targetFilter = _a.targetFilter, targetFilterValue = _a.targetFilterValue;
            if (targetFilter === undefined) {
                return null;
            }
            return (React.createElement(Dropdown_1.Dropdown, { onChange: _this.onDropdownFilterValueChanged, options: targetFilter.options || [], placeholder: "Value...", value: targetFilterValue || undefined }));
        };
        _this.renderTextMatchFilter = function () {
            var _a = _this.state, targetFilter = _a.targetFilter, targetFilterValue = _a.targetFilterValue;
            if (!targetFilter) {
                return null;
            }
            return (React.createElement(TextField_1.TextField, { inputMaskType: targetFilter.inputMaskType, onChange: _this.onTextFilterValueChanged, placeholder: "Value...", value: targetFilterValue || undefined }));
        };
        _this.renderDatePickerFilter = function (includeTime) {
            var _a = _this.state, endDate = _a.endDate, startDate = _a.startDate, targetFilter = _a.targetFilter, targetOperatorValue = _a.targetOperatorValue;
            if (!targetFilter) {
                return null;
            }
            return (React.createElement(React.Fragment, null,
                targetOperatorValue === 'between' && (React.createElement(React.Fragment, null,
                    React.createElement(Datetime, { endDate: endDate, includeTime: includeTime, onChange: _this.onStartDateChanged, selected: startDate, selectsStart: true, startDate: startDate }),
                    React.createElement(Datetime, { endDate: endDate, includeTime: includeTime, onChange: _this.onEndDateChanged, selected: endDate, selectsEnd: true, startDate: startDate }))),
                targetOperatorValue !== 'between' &&
                    targetOperatorValue !== 'today' &&
                    targetOperatorValue !== 'yesterday' &&
                    targetOperatorValue !== 'lastWeek' &&
                    targetOperatorValue !== 'lastMonth' && (React.createElement(Datetime, { includeTime: includeTime, onChange: _this.onDateFilterValueChanged, selected: _this.state.startDate, selectsStart: true }))));
        };
        _this.renderNumberFilter = function () {
            var _a = _this.state, targetFilter = _a.targetFilter, targetFilterValue = _a.targetFilterValue, targetFilterValue2 = _a.targetFilterValue2, targetOperatorValue = _a.targetOperatorValue;
            if (!targetFilter) {
                return null;
            }
            return (React.createElement(React.Fragment, null, targetOperatorValue === 'between' ? (React.createElement(React.Fragment, null,
                React.createElement(NumberInputField, { inputMaskType: targetFilter.inputMaskType, onChange: _this.onTextFilterValueChanged, placeholder: "Min Number...", style: { width: 'auto' }, type: "number", value: targetFilterValue || undefined }),
                React.createElement(NumberInputField, { inputMaskType: targetFilter.inputMaskType, onChange: _this.onTextFilterValue2Changed, placeholder: "Max Number...", style: { width: 'auto' }, type: "number", value: targetFilterValue2 || undefined }))) : (React.createElement(NumberInputField, { inputMaskType: targetFilter.inputMaskType, onChange: _this.onTextFilterValueChanged, placeholder: "Number...", style: { width: 'auto' }, type: "number", value: targetFilterValue || undefined }))));
        };
        _this.state = {
            endDate: null,
            filtering: false,
            startDate: null,
            targetFilter: undefined,
            targetOperatorValue: undefined,
        };
        return _this;
    }
    Grid.prototype.render = function () {
        var filtering = this.state.filtering;
        var _a = this.props, actionItems = _a.actionItems, _b = _a.entityName, entityName = _b === void 0 ? 'item' : _b, _c = _a.fetchDataElement, fetchDataElement = _c === void 0 ? React.createElement(Loader_1.Loader, { active: true }) : _c, gridLoader = _a.gridLoader, _d = _a.hideShowingText, hideShowingText = _d === void 0 ? false : _d, isFetching = _a.isFetching, _f = _a.pluralEntityName, pluralEntityName = _f === void 0 ? 'items' : _f, _g = _a.selectable, selectable = _g === void 0 ? false : _g, _h = _a.selectedItems, selectedItems = _h === void 0 ? [] : _h, style = _a.style;
        return (React.createElement("div", { className: "tableContainer", style: style || { margin: '20px' } },
            React.createElement(React.Fragment, null,
                React.createElement("div", { className: "tableContainer__header" },
                    this.renderSearch(),
                    filtering && this.renderFilterSelection(),
                    this.renderSelectedFilters(),
                    React.createElement(BulkActionsWrapper, { style: selectedItems.length >= 1
                            ? {
                                background: index_1.colors.black05,
                                borderRadius: '4px',
                                padding: '1.5rem',
                            }
                            : { background: undefined } }, !selectable ? (!hideShowingText && (React.createElement(ShowingText, null, this.getShowText()))) : selectedItems.length >= 1 ? (React.createElement(React.Fragment, null,
                        React.createElement("div", { style: {
                                fontSize: index_1.fontSize.body,
                                fontWeight: 700,
                            } },
                            selectedItems.length,
                            ' ',
                            selectedItems.length === 0 || selectedItems.length > 1
                                ? pluralEntityName
                                : entityName,
                            ' ',
                            "selected"),
                        React.createElement(ActionItemsWrapper, null, actionItems))) : (!hideShowingText && (React.createElement(ShowingText, null, this.getShowText()))))),
                React.createElement("div", { className: "tableContainer__grid" }, gridLoader
                    ? this.renderTable()
                    : isFetching
                        ? fetchDataElement
                        : this.renderTable()))));
    };
    Grid.prototype.getShowText = function () {
        var _a = this.props, count = _a.count, _b = _a.data, data = _b === void 0 ? [] : _b, _c = _a.entityName, entityName = _c === void 0 ? 'item' : _c, _d = _a.pluralEntityName, pluralEntityName = _d === void 0 ? 'items' : _d, _f = _a.titleCaseShowingText, titleCaseShowingText = _f === void 0 ? true : _f, totalOnPage = _a.totalOnPage;
        var total = count ? count : data.length;
        if (total < 1) {
            return '';
        }
        if (total === 1) {
            var singular = titleCaseShowingText ? titleCase_1.titleCase(entityName) : entityName;
            return "Showing 1 " + singular;
        }
        var plural = titleCaseShowingText
            ? titleCase_1.titleCase(pluralEntityName)
            : pluralEntityName;
        var numberOnPage = totalOnPage ? totalOnPage : data.length;
        return "Showing " + numberOnPage + " of " + total + " " + plural;
    };
    Grid.prototype.renderLoader = function (modifiedColumns) {
        var _a = this.props, gridLoader = _a.gridLoader, _b = _a.loaderRows, loaderRows = _b === void 0 ? 10 : _b;
        return Array.from({ length: loaderRows }, function (_, k) { return (React.createElement(semantic_ui_react_1.Table.Row, { key: k }, Array.from({ length: modifiedColumns.length }, function (_, k) { return (React.createElement(semantic_ui_react_1.Table.Cell, { key: k }, gridLoader)); }))); });
    };
    Grid.prototype.renderEmptyState = function () {
        var _a = this.props, _b = _a.data, data = _b === void 0 ? [] : _b, noResultsFound = _a.noResultsFound;
        if (data.length !== 0) {
            return null;
        }
        if (noResultsFound !== undefined) {
            return noResultsFound;
        }
        return (React.createElement(EmptyState_1.EmptyState, { image: React.createElement(__1.Icons.MagnifyingGlass, null), label: "No Results Found.", sublabel: "There is no data for given search criteria." }));
    };
    return Grid;
}(React.Component));
exports.Grid = Grid;
var Datetime = styled_1.default(DatetimePicker_1.DatetimePicker)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: white !important;\n"], ["\n  background-color: white !important;\n"])));
var FilterDataLink = styled_1.default.a(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  margin: 0 1rem;\n\n  &:hover {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  font-size: ", ";\n  line-height: ", ";\n  margin: 0 1rem;\n\n  &:hover {\n    color: ", ";\n  }\n"])), function (props) { return props.theme.colors.primary; }, index_1.fontSize.body, index_1.lineHeight.body, function (props) { return props.theme.colors.primary; });
var FilterFieldContainer = function (_a) {
    var alignItemsVertically = _a.alignItemsVertically, children = _a.children;
    if (alignItemsVertically) {
        return (React.createElement(FilterFieldDiv, { style: { flexDirection: 'column' } }, children));
    }
    return React.createElement(FilterFieldDiv, null, children);
};
var FilterFieldDiv = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-start;\n\n  > div {\n    margin-right: 0.5em;\n    margin-top: 1rem;\n    margin-bottom: 3px;\n  }\n"], ["\n  display: flex;\n  align-items: flex-start;\n\n  > div {\n    margin-right: 0.5em;\n    margin-top: 1rem;\n    margin-bottom: 3px;\n  }\n"])));
var NumberInputField = styled_1.default(TextField_1.TextField)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  width: auto;\n  max-width: 150px;\n"], ["\n  width: auto;\n  max-width: 150px;\n"])));
var filterSectionWrapper = {
    background: index_1.colors.black05,
    borderRadius: '4px',
    margin: "2rem 0",
    padding: '1.5rem',
};
var flexSpaceBetween = {
    display: 'flex',
    justifyContent: 'space-between',
};
var topRightFilterLabel = {
    color: '#0c0033',
    fontSize: index_1.fontSize.caption,
    lineHeight: index_1.lineHeight.caption,
    marginRight: '8px',
};
var BulkActionsWrapper = styled_1.default.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n"])));
var ActionItemsWrapper = styled_1.default.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var SelectedFiltersWrapper = styled_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  margin: 2rem 0;\n"], ["\n  margin: 2rem 0;\n"])));
var FilterSelectionSpan = styled_1.default.span(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  & img {\n    margin-left: 1rem;\n    height: 2rem;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n\n  & img {\n    margin-left: 1rem;\n    height: 2rem;\n  }\n"])));
var ShowingText = styled_1.default.h6(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  margin: 0;\n"], ["\n  margin: 0;\n"])));
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
//# sourceMappingURL=index.js.map